import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setInspectionType } from "../../../pages/Form/formSlice";

const InspectionType = ({ types, inspectionTypeError, onTypeSelect }) => {
  const [value, setValue] = useState();
  const [valueName, setValueName] = useState();
  const [resetButtonVisible, setResetButtonVisible] = useState(false);
  const inspectionType = useSelector((state) => state.form.inspectionType);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("val changed", value);
    localStorage.setItem("inspektionsart", JSON.stringify(value));
    dispatch(setInspectionType(valueName));
  }, [value]);

  useEffect(() => {
    if (value !== "") {
      setResetButtonVisible(true);
    } else {
      setResetButtonVisible(false);
    }
  }, [value]);

  const handleRadioChange = (e) => {
    setValue(e.target.value);
    setValueName(e.target.id);
    onTypeSelect(e.target.value);
  };

  return (
    <div
      className="card"
      style={{
        marginTop: 10,
        padding: 10,
        border: inspectionTypeError
          ? "1px solid #f1807e"
          : "1px solid #D9D9D9 ",
      }}
    >
      <label>{"Art der Begehung*"}</label>
      {types.map((type, key) => {
        return (
          <div className="form-check" key={key}>
            <input
              className="form-check-input"
              type="radio"
              id={type.name}
              value={type.id}
              name={"inspektionsart"}
              onChange={handleRadioChange}
            />
            <label htmlFor={type.name} className="form-check-label">
              {type.name}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default InspectionType;
